module.exports = __webpack_public_path__ + "static/media/S17.6528b9d2.png";